import { FiImage } from '@react-icons/all-files/fi/FiImage';

import { GetLeadByExternalIdPhotos200 } from '../../../../../../../services/marketplace/generated/kubb/models/GetLeadByExternalIdPhotos';
import DocumentsPanelRow, { ViewFileButton } from './DocumentsPanelRow';

type PhotoRowProps = {
  photo: GetLeadByExternalIdPhotos200[number];
};

const PhotoRow = ({ photo }: PhotoRowProps) => (
  <DocumentsPanelRow
    thumbnailUrl={photo.url}
    fallbackIcon={FiImage}
    name={photo.label ?? 'Photo'}
    actions={<ViewFileButton url={photo.url} />}
  />
);

export default PhotoRow;
